
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ggRKCpqDPjiY9sqqwRmD3_45i9QhT6EDTmkhRC9lQhBGUMMeta } from "/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexuQcN_nE1vXU4DeCIi3UngbPCSQyNLGe8ZuArZF5GSuoMeta } from "/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchB_45z9vcG6dQfFN4J43YHFXQ8Vr6GaOwkHD4GdnuYq_f0Meta } from "/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexBe14PcZ63WHoRaJevKXK8Kc3gKHFvozEvOAoapCFHLwMeta } from "/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93c9jxAxlhD_454IXHDMcE7dbBfqlOn0v4PO15zb8ZqsKSIMeta } from "/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexU4VjU_suGk67Ha5guGF3Vncd1O_iWJWqMFFrke7GQ_45wMeta } from "/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93_45OWwKbUDoer1KEqjSIBH9V4p9B_45bC6ZXuw__45gbIGYvsMeta } from "/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexpb17gJeleRAdNg_LEMkOF7yTNpH6Lj_irU0x8mulVhAMeta } from "/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93d_38ORsUi05_WIC4qjGRhYXjzoVEHrlYI_45dcmpMC5tUMeta } from "/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexKTYKdUl5SmMH9sArpNiOz2IsqUDE6y0lGy_45AsmDDJpwMeta } from "/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexHg_UXVlvddgtk__45UghRZoExkC9jIVNoRJaDQemHyvEkMeta } from "/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexU4VjU_suGk67Ha5guGF3Vncd1O_iWJWqMFFrke7GQ_45wMeta || {},
    component: () => import("/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexpb17gJeleRAdNg_LEMkOF7yTNpH6Lj_irU0x8mulVhAMeta || {},
    component: () => import("/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexKTYKdUl5SmMH9sArpNiOz2IsqUDE6y0lGy_45AsmDDJpwMeta || {},
    component: () => import("/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexHg_UXVlvddgtk__45UghRZoExkC9jIVNoRJaDQemHyvEkMeta || {},
    component: () => import("/codebuild/output/src246281320/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]